var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getSvg,{tag:"component",attrs:{"data-component":"icon","data-colour":_vm.colour,"data-icon":_vm.icon,"alt":_vm.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }